import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Domain as WebsideDomain } from "../../../../lib/Domain/Webside";
@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css']
})
export class ProductListComponent implements OnInit {
  public productlists: WebsideDomain.IProduct[] = [];
  public selectedProduct: WebsideDomain.IProduct;
  messageTitle: string;
  messageBody: string;
  OnMessageOKCallback: (callback: () => void) => void;
  OnMessageCancelCallBack: (callback: () => void) => void;

  constructor(private httpService: HttpService, private modalService: NgbModal) { }

  async ngOnInit() {
    this.productlists = await this.httpService.product.List();
  }
  OnCreateNew(content) {
    this.selectedProduct = undefined;
    this.modalService.open(content);
  }
  async OnEdit(content, item: WebsideDomain.IProduct) {
    this.selectedProduct = item;
    this.modalService.open(content);
  }
  async OnDetail(content, item: WebsideDomain.IProduct) {
    this.selectedProduct = item;
    this.modalService.open(content);
  }
  public onCheckPremission() {
    return (this.httpService.userinfo.usertype >=0x20);
  }
  async OnSave($event) {
    let { Item, isCreated, callback } = $event;
    try {
      const result = await this.httpService.product.Update(Item);
      if (isCreated) {
        this.productlists.push(result);
      } else {
        let index = this.productlists.findIndex((v) => {
          return v.uuid === result.uuid;
        });
        if (index > 0) {
          this.productlists[index] = result;
        }
      }
      callback(null);
    } catch (erro) {
      callback(erro);
    }
  }
  async OnDelete(content, $event: WebsideDomain.IProduct) {
    this.messageTitle = "刪除產品";
    this.messageBody = `確定要刪除產品${$event.deviceserialno} ${$event.serialno}?\r\n此動作將會刪除該設備下擁有的資料並不可還原\r\n按確定繼續`;
    this.OnMessageOKCallback = (d) => {
      try {
        this.httpService.product.Delete($event).then(() => {
          let index = this.productlists.findIndex((v) => {
            return (v.uuid === $event.uuid);
          });
          if (index > -1) {
            this.productlists.splice(index, 1);
          }
        });
      } catch (erro) {
      }
      if (d) { d(); }
    };
    this.OnMessageCancelCallBack = (d) => {
      if (d) { d(); }
    };
    this.modalService.open(content);
  }
  async OnAuth(content, item: WebsideDomain.IProduct) {
    this.messageTitle = "驗證";
    this.messageBody = `和雲端服務取得設備驗証`;
    this.OnMessageOKCallback = undefined;
    this.OnMessageCancelCallBack = (d) => {
      if (d) { d(); }
    };
    this.modalService.open(content);
    this.httpService.product.Auth(item.serialno, item.hash).then(() => {
      this.messageBody = `${item.deviceserialno}\r\n${item.serialno}雲端驗証完成`;
    }).catch((erro) => {
      this.messageBody = `雲端驗証失敗`;
    })
  }


}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/product-list/product-list.component.ts